import Errorpage from './404.vue'
export default Errorpage



// WEBPACK FOOTER //
// ./src/pages/404/index.js